import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgModel, NgForm } from '@angular/forms';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';

import { Card } from './card.model';
import { CardPopupService } from './card-popup.service';
import { CardService } from './card.service';
import { Payment, PaymentService, PaymentType} from '../payment';
import { PaymentItem, PaymentItemService} from '../payment-item';
import { studentGlobalLocations } from '../../shared/constants/student.locations.constants';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { CRUD_ACTIONS, Principal } from '../../shared';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { School, SchoolService } from '../school';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-card-pay-dialog',
    templateUrl: './card-pay-dialog.component.html'
})
export class CardPayDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy  {

    card: Card;
    payment: Payment;
    paymentItem: PaymentItem;
    isSaving: boolean;

    search = this.studentTypeaheadService.search;
    resultFormatter = this.studentTypeaheadService.resultFormatter;
    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.payment.payer['user']);

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private cardService: CardService,
        public activeModal: NgbActiveModal,
        public studentTypeaheadService: StudentTypeaheadService,
        public schoolService: SchoolService,
        public alertService: AlertService,
        public principal: Principal,
        public paymentService: PaymentService,
        public paymentItemService: PaymentItemService,
        private eventManager: EventManager
    ) {
        super(schoolService, alertService, principal);
    }

    clear() {
        this.isSaving = false;
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        if (this.payment.payer instanceof Object) {
            this.isSaving = true;
            this.paymentService.create(this.payment)
                .subscribe((res: Payment) =>
                    this.onPaymentSaveSuccess(res, CRUD_ACTIONS.CREATE),
                    (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            let payerInput = form !== undefined ? form.controls['payer'] : null;
            if (payerInput !== null) {
                payerInput.reset();
            }
        }
    }

    private onPaymentSaveSuccess(result: Payment, action: string) {
        this.paymentItem.payment = result;
        this.paymentItemService.create(this.paymentItem)
                .subscribe((res: PaymentItem) =>
                    this.onPaymentItemSaveSuccess(res),
                    (res: HttpErrorResponse) => this.onSaveError(res));
    }

    private onPaymentItemSaveSuccess(result: Payment) {
        this.card.totalPaid += this.paymentItem.amount;
        this.eventManager.broadcast({ name: 'cardListModification',  content: {
            action: CRUD_ACTIONS.UPDATE,
            content: this.card
        } });
        this.eventManager.broadcast({ name: 'paymentItemListModification',  content: {
            action: CRUD_ACTIONS.CREATE,
            content: result
        } });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    ngOnInit() {
        this.payment = new Payment();
        this.payment.payer = this.card.student;
        let today: Date = new Date();
        this.payment.paymentDate = {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            day: today.getDate()
        };
        this.paymentItem = new PaymentItem();
        this.paymentItem.beneficiary = this.card.student;
        this.paymentItem.card = this.card;
    }

    ngOnDestroy() {

    }

}

@Component({
    selector: 'jhi-card-pay-popup',
    template: ''
})
export class CardPayPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private cardPopupService: CardPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.cardPopupService
                .open(CardPayDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/card/card-pay-dialog.component.ts